//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/customer/banking-configs -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    automaticWithdrawalEnabled: t.boolean,
    deposits: t.interface({
        channels: t.interface({
            backoffice: t.interface({
                depositResultHtml: t.union([t.null, t.undefined, t.string]),
                realexConfigId: t.union([t.null, t.undefined, t.string]),
                secureTradingConfigId: t.union([t.null, t.undefined, t.string]),
            }),
            default: t.interface({
                depositResultHtml: t.union([t.null, t.undefined, t.string]),
                realexConfigId: t.union([t.null, t.undefined, t.string]),
                secureTradingConfigId: t.union([t.null, t.undefined, t.string]),
            }),
        }),
        minimalAmount: t.number,
    }),
    id: t.string,
    kyc: t.interface({
        enabled: t.boolean,
        maxLimit: t.number,
    }),
    provider: t.string,
    withdrawals: t.interface({
        channels: t.interface({
            backoffice: t.interface({
                depositResultHtml: t.union([t.null, t.undefined, t.string]),
                realexConfigId: t.union([t.null, t.undefined, t.string]),
                secureTradingConfigId: t.union([t.null, t.undefined, t.string]),
            }),
            default: t.interface({
                depositResultHtml: t.union([t.null, t.undefined, t.string]),
                realexConfigId: t.union([t.null, t.undefined, t.string]),
                secureTradingConfigId: t.union([t.null, t.undefined, t.string]),
            }),
        }),
        minimalAmount: t.number,
    }),
});
export type Response200Type = {
    automaticWithdrawalEnabled: boolean;
    deposits: {
        channels: {
            backoffice: {
                depositResultHtml?: null | undefined | string;
                realexConfigId?: null | undefined | string;
                secureTradingConfigId?: null | undefined | string;
            };
            default: {
                depositResultHtml?: null | undefined | string;
                realexConfigId?: null | undefined | string;
                secureTradingConfigId?: null | undefined | string;
            };
        };
        minimalAmount: number;
    };
    id: string;
    kyc: {
        enabled: boolean;
        maxLimit: number;
    };
    provider: string;
    withdrawals: {
        channels: {
            backoffice: {
                depositResultHtml?: null | undefined | string;
                realexConfigId?: null | undefined | string;
                secureTradingConfigId?: null | undefined | string;
            };
            default: {
                depositResultHtml?: null | undefined | string;
                realexConfigId?: null | undefined | string;
                secureTradingConfigId?: null | undefined | string;
            };
        };
        minimalAmount: number;
    };
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyCustomerBankingConfigsRequest"
 */
export const openapi_proxy_customer_banking_configs = async (api_url: string, api_timeout: number, backendToken: string, _params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/customer/banking-configs${query}`;
    
    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyCustomerBankingConfigsParamsType = ParamsType;

export type OpenapiProxyCustomerBankingConfigsResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyCustomerBankingConfigsResponse200Type = Response200Type;

export const openapiProxyCustomerBankingConfigsRequest = async (api_url: string, api_timeout: number, backendToken: string, _params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyCustomerBankingConfigsResponseType> => {
    const response = await openapi_proxy_customer_banking_configs(api_url, api_timeout, backendToken, _params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyCustomerBankingConfigsRequest - unhandled response ${response.status}`);
};

